<template>
  <!-- <transition name="modal"> -->
  <div class="game-scaleable-wrapper" id="game-scaleable-wrapper">
    <div class="game-very-specific-design" id="game-very-specific-design" :style="setVerySpecyficDesginStyle()">
      <button type="close" title="Zamknij ćwiczenie" name="close" @click="closeGame()" class="close-button">
        <svg fill="#ffffff" height="55" viewBox="0 0 24 24" width="55">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            fill="rgb(230, 230, 230)"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
      <div class="game-wrapper">
        <tr-game-body>
          <div class="game-body" slot="body">
            <component
              :is="componentEngine"
              :start-game-config="gameConfig"
              :assets="assets"
              :game-id="gameData.id"
              :key="componentKey"
            ></component>
          </div>
        </tr-game-body>
        <tr-ui-title
          v-for="(title, index) in gameData.item.title"
          :key="gameData.id + '_' + index"
          class="freePosition"
          :title-text="title.text"
          :audio="title.audio"
          :pos="title.pos"
          :size="title.size"
          :katex="title.katex"
          :css-style="title.cssStyle"
          :multi-stage="multiStage"
        ></tr-ui-title>
        <div class="slider-button-box">
          <b-button
            :key="'button-map-' + index"
            v-for="(map, index) in getMbMapObjSrc()"
            class="show-slider-button"
            v-b-toggle="'sidebar-map-' + index"
            :style="map.style"
          >
            <span class="slider-button-text">{{
              setMapTitle(map.name, 'MAPA', getMbMapObjSrc().length > 1 ? index + 1 : null)
            }}</span>
          </b-button>
          <b-button
            :key="'button-video-' + index2"
            v-for="(video, index2) in getMbVideoObjSrc()"
            class="show-slider-button"
            v-b-toggle="'mb-video-sidebar-' + index2"
            :style="video.style"
          >
            <span class="slider-button-text">{{
              setMapTitle(video.name, 'FILM', getMbVideoObjSrc().length > 1 ? index2 + 1 : null)
            }}</span>
          </b-button>
          <b-button
            class="show-slider-button"
            v-b-toggle.sidebar-right
            v-if="isActivatorButtonVisible"
            :style="getTrSliderStyle()"
          >
            <span class="slider-button-text"> {{ getTrSliderTitle('NOTATNIK') }} </span>
          </b-button>
        </div>
        <mb-map title-text="Mapa" :map-obj="getMbMapObj()" v-if="mapButtonVisibleStatus">
          <!-- <template v-slot:activator> </template> -->
        </mb-map>
        <mb-ui-video title-text="Film" :video-obj="getMbUiVideoObj()" v-if="videoButtonVisibleStatus">
          <!-- <template v-slot:activator> </template> -->
        </mb-ui-video>
        <tr-slider class="tr-slider" :title-text="getTrSliderTitle('Notatnik')">
          <template v-slot:activator>
            <div class="icon-image">
              <!-- <img draggable="false" :src="imagePath('przybornik_menuRysuj')" class="icon-off" /> -->
              <div
                draggable="false"
                :style="`background-image:url(${imagePath('przybornik_menuRysuj_ON')});`"
                :class="[tool === 'paintBrush' ? 'selected' : '']"
                class="icon-on"
                @click="changeTool('paintBrush')"
              ></div>
              <div
                draggable="false"
                :style="`background-image:url(${imagePath('przybornik_gumka')});`"
                :class="[tool === 'eraser' ? 'selected' : '']"
                class="icon-on"
                @click="changeTool('eraser')"
              ></div>
              <div
                draggable="false"
                :style="`background-image:url(${imagePath('przybornik_kosz')});`"
                class="icon-on"
                @click="clearCanvas()"
              ></div>
            </div>
          </template>
          <template v-slot:content>
            <tr-slider-canvas :grid="trSliderWithGrid"></tr-slider-canvas>
          </template>
        </tr-slider>
        <tr-game-status
          :game-status="actualGameStatus"
          v-show="!gameData.item.hideControlPanel && !gameConfig.withoutCheck && gameData.item.engine != 'croppImg'"
        ></tr-game-status>
        <tr-game-control-panel
          @changeGameStatus="changeGameStatus()"
          v-if="!gameData.item.hideControlPanel"
        ></tr-game-control-panel>
        <tr-game-points-panel v-if="visiblePointsUI"></tr-game-points-panel>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import TrUiTitle from './UI/TrUiTitle/TrUiTitle';
import TrGameBody from './TrGameBody/TrGameBody';
import TrGameControlPanel from './UI/TrGameControlPanel/TrGameControlPanel';
import TrGameStatus from './UI/TrGameStatus/TrGameStatus';
import TrGamePointsPanel from './UI/TrPoints/TrGamePointsPanel';
/** slider canvas components */
import MbUiVideo from './UI/MbUiVideo/MbUiVideo';
import MbMap from './UI/MbMap/MbMap';
import TrSlider from './UI/TrSlider/TrSlider';
import TrSliderCanvas from './UI/TrSlider/TrSliderCanvas';
/** gameEngins components */
import TrTestMulti from './GameEngines/TestMulti/TrTestMulti';
import TrTestMultiCheckboxImpr from './GameEngines/TestMulti/TrTestMultiCheckboxImpr';
import TrMultiCheckbox from './GameEngines/TestMulti/TrMultiCheckbox';
import TrMultiCheckboxImpr from './GameEngines/TestMulti/TrMultiCheckboxImpr';
import TrTestBoolean from './GameEngines/TestBoolean/TrTestBoolean';
import TrTextBlockWithInput from './GameEngines/TextBlockWithInput/TrTextBlockWithInput';
import TrTextBlockWithInputImpr from './GameEngines/TextBlockWithInput/TrTextBlockWithInputImpr';
import TrInputOnBackground from './GameEngines/InputOnBackground/TrInputOnBackground';
import TrInputOnBackgroundWithoutCheck from './GameEngines/InputOnBackground/TrInputOnBackgroundWithoutCheck';
import TrTestSelectGame from './GameEngines/SelectGame/TrTestSelectGame';
import TrSelectGameWithText from './GameEngines/SelectGame/TrSelectGameWithText';
import TrSelectImage from './GameEngines/SelectImage/TrSelectImage';
import TrSelectGame from './GameEngines/SelectGame/TrSelectGame';
import TrTextAreaOnBackground from './GameEngines/TextAreaOnBackground/TrTextAreaOnBackground';
import TrSelectGameWithTextImpr from './GameEngines/SelectGame/TrSelectGameWithTextImpr';
import TrStepByStep from './GameEngines/StepByStep/TrStepByStep';
import TrStepByStepComics from './GameEngines/StepByStep/TrStepByStepComics';
//PS
import PsPrintInput from '__mainSrcDir/components/TrGame/v4/GameEngines/PsPrintInput/PsPrintInput';
import PsConnect from '__mainSrcDir/components/TrGame/v4/GameEngines/PsConnect/PsConnect';
//MB
import TrCroppImg from './GameEngines/MbCroppImg/MbCroppImg';
import TrPuzzle from './GameEngines/MbPuzzle/MbPuzzle';
import TrBalloonsGame from './GameEngines/MbBalloonsGame/MbBalloonsGame';
import TrImageSelect from './GameEngines/MbImageSelect/MbImageSelect';
import TrMemory from './GameEngines/MbMemory/MbMemory';
import TrTestWithPoints from './GameEngines/MbTestWithPoints/MbTestWithPoints';
import TrSteps from './GameEngines/MbSteps/MbSteps';
import MbListenAndPoint from './GameEngines/MbListenAndPoint/MbListenAndPoint';
import MbDecisionTree from './GameEngines/MbDecisionTree/MbDecisionTree';
import MbRoulette from './GameEngines/MbRoulette/MbRoulette';
import MbQuiz from '__mainSrcDir/components/TrGame/v4/GameEngines/MbQuiz/MbQuiz';
import MbQuizWithBorder from '__mainSrcDir/components/TrGame/v4/GameEngines/MbQuiz/MbQuizWithBorder';
import MbCoding from '__mainSrcDir/components/TrGame/v4/GameEngines/MbCoding/MbCoding';
import MbTest from '__mainSrcDir/components/TrGame/v4/GameEngines/MbTest/MbTest';
import MbPathChecker from '__mainSrcDir/components/TrGame/v4/GameEngines/MbPathChecker/MbPathChecker';
import MbMonograph from '../../MbMonograph/MbMonograph';
import MbFilm from '__mainSrcDir/components/TrGame/v4/GameEngines/MbFilm/MbFilm';
import MbQuestion from '__mainSrcDir/components/TrGame/v4/GameEngines/MbQuestion/MbQuestion';
import MbDragAndDrop from '__mainSrcDir/components/TrGame/v4/GameEngines/MbDragAndDrop/MbDragAndDrop';
import MbGallery from '__mainSrcDir/components/TrGame/v4/GameEngines/MbGallery/MbGallery';
import MbFindNumber from '__mainSrcDir/components/TrGame/v4/GameEngines/MbFindNumber/MbFindNumber';
// MZ
import MzColoring from './GameEngines/MzColoring/MzColoring';
import MzLabyrinth from './GameEngines/MzLabyrinth/MzLabyrinth';
import MzLabyrinth2 from './GameEngines/MzLabyrinth/MzLabyrinth2';
import MzKaraoke from './GameEngines/MzKaraoke/MzKaraoke';
import MzListenAndPoint from './GameEngines/MzListenAndPoint/MzListenAndPoint';
import MzLookPointAndListen from './GameEngines/MzLookPointAndListen/MzLookPointAndListen';
import MzChooseSlide from './GameEngines/MzChooseSlide/MzChooseSlide';
// MJ
import MjTrueFalseTest from '__mainSrcDir/components/TrGame/v4/GameEngines/MjTrueFalseTest/MjTrueFalseTest';
// VUE
import MpChooseAnswer from './GameEngines/MpChooseAnswer/MpChooseAnswer';
import MpChooseAnswer16 from './GameEngines/MpChooseAnswer/MpChooseAnswer16';
import MpChooseAnswer04 from './GameEngines/MpChooseAnswer/MpChooseAnswer04';
import MpCrossword from './GameEngines/MpCrossword/MpCrossword';
import MpCrossword2 from './GameEngines/MpCrossword/MpCrossword2';
import MpFindWords from './GameEngines/MpFindWords/MpFindWords';
import MpFindWordsByClick from './GameEngines/MpFindWords/MpFindWordsByClick';
import MpGalleryFade from './GameEngines/MpGallery/MpGalleryFade';
import MpGallerySvgAnime from './GameEngines/MpGallery/MpGallerySvgAnime';
// import MpGallerySvgSnap from './GameEngines/MpGallery/MpGallerySvgSnap';
import MpMendelejew from './GameEngines/MpMendelejew/MpMendelejew';
import MpMillionaires from './GameEngines/MpMillionaires/MpMillionaires';
import MpModelShow from './GameEngines/MpModel3d/MpModel3d';
import MpTextSelect from './GameEngines/MpTextSelect/MpTextSelect';
import { Howler } from 'howler';

// CREATE JS
import MpCreateJS from './GameEngines/MpCreateJS/MpCreateJS';

export default {
  name: 'tr-game',
  props: {
    multibookType: {
      type: String,
      default: `${process.env.MULTIBOOK_TYPE}`,
    },
  },
  components: {
    MjTrueFalseTest,
    MbUiVideo,
    MbMap,
    TrUiTitle,
    TrGameBody,
    TrGameControlPanel,
    TrGameStatus,
    TrGamePointsPanel,
    TrSlider,
    TrSliderCanvas,
    TrTestMulti,
    TrTestMultiCheckboxImpr,
    TrTestBoolean,
    TrTextBlockWithInput,
    TrInputOnBackground,
    TrInputOnBackgroundWithoutCheck,
    TrTestSelectGame,
    TrSelectGameWithText,
    TrSelectImage,
    MpFindWords,
    MpFindWordsByClick,
    MpModelShow,
    MpTextSelect,
    MpChooseAnswer,
    MpChooseAnswer16,
    MpChooseAnswer04,
    MpCrossword,
    MpCrossword2,
    MpMillionaires,
    MpMendelejew,
    MpGalleryFade,
    MpGallerySvgAnime,
    // MpGallerySvgSnap,
    MpCreateJS,
    TrSelectGame,
    TrMultiCheckbox,
    TrMultiCheckboxImpr,
    TrTextBlockWithInputImpr,
    TrTextAreaOnBackground,
    TrSelectGameWithTextImpr,
    TrStepByStep,
    TrTestWithPoints,
    TrStepByStepComics,
    TrCroppImg,
    PsPrintInput,
    PsConnect,
    TrBalloonsGame,
    TrImageSelect,
    TrMemory,
    MbListenAndPoint,
    MbDecisionTree,
    MbRoulette,
    TrSteps,
    TrPuzzle,
    MzColoring,
    MzLabyrinth,
    MzLabyrinth2,
    MzKaraoke,
    MzListenAndPoint,
    MzLookPointAndListen,
    MzChooseSlide,
    MbQuiz,
    MbQuizWithBorder,
    MbCoding,
    MbTest,
    MbPathChecker,
    MbMonograph,
    MbFilm,
    MbQuestion,
    MbDragAndDrop,
    MbGallery,
    MbFindNumber,
  },
  data() {
    return {
      uiType: ['TrSlider', 'TrSliderWithGrid'],
      prevRoute: null,
      isActivatorButtonVisible: false,
      mapButtonVisibleStatus: false,
      videoButtonVisibleStatus: false,
    };
  },
  mounted() {
    let $innerWindow = $('.game-scaleable-wrapper');
    let $el = $('.game-very-specific-design');
    let elHeight = $el.outerHeight();
    let elWidth = $el.outerWidth();

    function doResize(event, ui) {
      let scale;
      scale = Math.min($innerWindow.width() / elWidth, $innerWindow.height() / elHeight);
      $el.css({
        transform: 'translate(-50%, -50%) ' + 'scale(' + scale + ')',
        '-webkit-transform-origin': 'center center',
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
      });
    }
    let resize = doResize.bind(this);
    let starterData = {
      size: {
        width: $innerWindow.width(),
        height: $innerWindow.height(),
      },
    };
    resize(null, starterData);

    if (this.gameConfig.withoutCheck) {
      this.$store.dispatch('disablingCheckAction');
    }
    this.isActivatorButtonVisible = this.showExtendedUI;
    this.mapButtonVisibleStatus = this.showMapButton;
    this.videoButtonVisibleStatus = this.showVideoButton;
  },
  destroyed() {
    if (this.$store.getters.realMultibookType) {
      this.$store.commit('CHANGE_MULTIBOOK_TYPE', this.$store.getters.realMultibookType);
      this.$store.commit('CHANGE_REAL_MULTIBOOK_TYPE', null);
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },

  methods: {
    setMapTitle(title, defaultTitle, index) {
      if (title) {
        return title;
      } else if (index) {
        return defaultTitle + ' ' + index;
      } else {
        return defaultTitle;
      }
    },
    changeTool(tool) {
      this.$store.commit('TrSliderCanvas/CHANGE_CANVAS_TOOLL', tool);
    },

    clearCanvas() {
      let myCanvas = this.$store.getters['TrSliderCanvas/canvas'];

      let ctx = myCanvas.getContext('2d');
      ctx.clearRect(0, 0, myCanvas.width, myCanvas.height);
    },
    executeOnShown(e) {
      // if (e.payload === true) {
      // this.isActivatorButtonVisible = !e.payload;
      // }
    },
    executeOnShownMap(e) {
      // if (e.payload === true) {
      // this.mapButtonVisibleStatus = !e.payload;
      // }
    },
    imagePath(iconId) {
      iconId = iconId || 'ikonaCwiczenie';
      let images = require.context('__mainSrcDir/assets/icons/book/toolbox/', false, /\.png$/);
      return images('./' + iconId + '.png');
    },
    getMbMapObjSrc() {
      let mapObj = this.getMbMapObj();
      if (mapObj.images) {
        return mapObj.images;
      } else {
        return [];
      }
    },
    getMbVideoObjSrc() {
      let mapObj = this.getMbUiVideoObj();
      if (mapObj.video) {
        return mapObj.video;
      } else {
        return [];
      }
    },
    getTrSliderTitle(defaultTitle) {
      let title = '';
      if (this.gameData.item.ui) {
        this.uiType.forEach((it) => {
          let obj = this.gameData.item.ui.find((x) => x.type == it);
          if (obj?.name) {
            title = obj.name;
          }
        });
      }
      return title ? title : defaultTitle;
    },
    getTrSliderStyle() {
      let style = {};
      if (this.gameData.item.ui) {
        this.uiType.forEach((it) => {
          // console.log(it);
          let obj = this.gameData.item.ui.find((x) => x.type == it);
          if (obj?.style) {
            Object.assign(style, obj.style);
          }
        });
      }
      return style;
    },
    getMbMapObj() {
      if (this.gameData.item.ui) {
        if (this.gameData.item.ui.some((x) => x.type == 'MbMap')) {
          return this.gameData.item.ui.find((x) => x.type == 'MbMap');
        } else {
          return {};
        }
      }
      return {};
    },
    getMbUiVideoObj() {
      if (this.gameData.item.ui) {
        if (this.gameData.item.ui.some((x) => x.type == 'MbUiVideo')) {
          return this.gameData.item.ui.find((x) => x.type == 'MbUiVideo');
        } else {
          return {};
        }
      }
      return {};
    },
    closeGame() {
      Howler.stop();
      const gamesRouterPaths = ['game', 'gameV2', 'gameV4'];
      this.$store.dispatch('closeGame');
      if (
        this.prevRoute &&
        (this.prevRoute.name == 'songs-view' ||
          this.prevRoute.name == 'games-grid-view' ||
          this.prevRoute.name == 'one-unit-grid-view' ||
          this.prevRoute.name == 'revise-grid-view' ||
          this.prevRoute.name == 'plakaty-grid-view')
      ) {
        this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params });
      } else {
        if (gamesRouterPaths.includes(this.$route.name)) {
          let actualPage = parseInt(this.$store.getters[`${this.correctModuleName}/getActualPage`]?.id);
          if (!_.isNil(actualPage)) {
            this.$router.push({
              name: 'page-view',
              params: { id: actualPage * 2 - 1, multibookType: `${this.$store.getters.multibookType}` },
            });
          } else {
            this.$router.push(`/`);
          }
        }
      }
    },
    resetGameAction() {
      this.containerEnd = _.cloneDeep(config.containerEnd);
      this.containerStart = _.cloneDeep(config.containerStart);
      this.correctList = _.cloneDeep(config.correctList);
    },
    setVerySpecyficDesginStyle() {
      return {
        width: `${this.mainContenWidth}px`,
        height: `${this.mainContenHeight}px`,
        transform: `translate(-50%, -50%) scale(${this.scale})`,
      };
    },
  },
  computed: {
    showMapButton() {
      let show = false;
      if (this.gameData.item.ui) {
        show = this.gameData.item.ui.some((x) => x.type == 'MbMap');
      }
      console.log(
        '%cTrGame -> UI MbMap: ' + show,
        'font-weight: bold; background: green; color: white; padding: 0px 10px'
      );
      return show;
    },
    showVideoButton() {
      let show = false;
      if (this.gameData.item.ui) {
        show = this.gameData.item.ui.some((x) => x.type == 'MbUiVideo');
      }
      console.log(
        '%cTrGame -> UI MbMap: ' + show,
        'font-weight: bold; background: green; color: white; padding: 0px 10px'
      );
      return show;
    },
    tool() {
      return this.$store.getters['TrSliderCanvas/tool'];
    },
    componentKey() {
      return this.$store.getters.componentKey;
    },
    correctModuleName() {
      let name = this.$store.getters.multibookType;
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    },
    componentEngine() {
      let author = this.gameData.item.author || 'TR';
      author = _.chain(author).toLower().upperFirst().value();
      return this.gameData.item.engine.replace(/^\w{0,1}/, function (a) {
        return `${author}${a.toUpperCase()}`;
      });
    },
    mainContenWidth() {
      return 1920 || this.$store.getters.mainContenWidth;
    },
    mainContenHeight() {
      return 1080 || this.$store.getters.mainContenHeight;
    },
    scale() {
      return this.$store.getters.scale || 1;
    },
    multiStage() {
      return this.$store.getters.multiStageTest;
    },
    gameData() {
      return this.$store.getters.gameData;
    },
    showExtendedUI() {
      let show = false;
      let showObj = false;
      if (this.gameData.item.ui) {
        show = this.uiType.reduce((acc, item) => {
          return acc || _.includes(this.gameData.item.ui, item);
        }, false);
        let uiArray = this.uiType;
        this.gameData.item.ui.forEach((x) => {
          uiArray.some((arrIt) => {
            console.log(arrIt + ' == ' + x.type);
            if (arrIt == x.type) {
              showObj = true;
            }
          });
        });
      }
      console.log('showExtendedUI -> show', show);
      console.log('showExtendedUI -> showObj', showObj);
      return show || showObj;
    },
    trSliderWithGrid() {
      let show = false;
      if (this.gameData.item.ui) {
        show = _.includes(this.gameData.item.ui, 'TrSliderWithGrid');
      }
      return show;
    },
    /**
     * get game confioguration data-key
     * @method gameConfig
     * @return {Object}   configuration objec
     */
    gameConfig() {
      return _.cloneDeep(Object.assign({}, this.gameData.item.gameConfig, { gamePath: this.gameData.item.gamePath }));
    },
    assets() {
      return _.cloneDeep(this.gameData.item.assets);
    },
    actualGameStatus() {
      return this.$store.getters.actualGameStatus;
    },
    visiblePointsUI() {
      return this.$store.getters.multistageVisiblePointsUI;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/variable';

.disableButton {
  display: none !important;
}
.icon-image {
  width: 100%;
  height: 70px;
  background-color: $firstIconColor;
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  .icon-on {
    cursor: pointer;
    width: 60px;
    height: 60px;
    background-size: 60px;
    margin-left: 10px;
    border-radius: 30px;
    box-shadow: inset 0 0 0px 0px $firstIconColor;
    transition: box-shadow 0.3s ease-in;
  }
  .icon-on:hover {
    box-shadow: inset 0 0 10px 4px $canvasActive;
    transition: box-shadow 0.3s ease-in;
  }
  .selected {
    box-shadow: inset 0 0 8px 4px $canvasActive;
  }
}

.game-container {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
}
.game-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  .game-body {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
  }
  .freePosition {
    display: flex;
    position: absolute;
  }
}
.game-scaleable-wrapper {
  resize: both;
  position: relative;
  background: $offScaleColor;
  height: 100vh;
  z-index: 8;
  overflow-y: hidden;
  overflow-x: hidden;
  .game-very-specific-design {
    width: 1920px;
    height: 1080px;
    text-align: center;
    background: $gamebackgroundColor;
    position: relative;
    left: 50%;
    top: 50%;
    transform-origin: center center 0;
  }
}

.close-button {
  pointer-events: auto;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 1;
  z-index: 1003;
  cursor: pointer;
  outline: none;
  border: none;
  background-color: $backgroundControlPanelColor;
  margin-right: 12px;
  margin-top: 22px;
  border-radius: 50%;
  display: flex;
  transform: scale(1);
  padding: 0;
  svg {
    path:first-child {
      fill: $bacgroundColor;
      transition: all 0.4s ease;
    }
  }
  &:hover {
    svg {
      path:first-child {
        fill: $closeActiveColor;
        transition: all 0.4s ease;
      }
    }
    transition: all 0.4s ease;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.test-button {
  display: flex;
  width: 20%;
  height: 5%;
  position: absolute;
  top: 92%;
  left: 58%;
  font-size: 30px;
  .test-button-text {
    width: 100%;
  }
}
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-very-specific-design {
  top: 0 !important;
  left: 0 !important;
  transform: translate(0%, 0%) scale(1) !important;
  transform-origin: center center 0;
  -webkit-font-smoothing: subpixel-antialiased;
  backface-visibility: hidden;
  .close-button {
    right: 26% !important;
    transform: translate(-50%, -50%) scale(0.7) !important;
  }
}
.slider-button-box {
  position: absolute !important;
  // top: 405px;
  left: 1890px;
  // height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  .show-slider-button {
    z-index: 1;
    // transition-delay: 0.2s;
    position: relative;
    height: 200px;
    padding-left: 0;
    padding-right: 0px;
    background-color: $firstIconColor;
    border-color: #ffffff;
    .slider-button-text {
      writing-mode: vertical-lr;
      text-orientation: mixed;
      font-size: larger;
      font-weight: bolder;
    }
    &:hover {
      color: $firstIconColor;
      background-color: #ffffff;
      border-color: $firstIconColor;
    }
  }
}
</style>
